import { createFretboardStrings } from '@fretgenius/ui';
import { useThemeStore } from '@/features/theme';

/**
 * FretboardStrings component renders all the strings on the fretboard
 */
export const FretboardStrings = createFretboardStrings({
  G: (props) => <g {...props} />,
  Line: (props) => <line {...props} />,
  useThemeStore,
});
